export enum ButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TEXT = 'TEXT',
  TERTIARY = 'TERTIARY',
}

export type ButtonAction =
  | 'UNKNOWN'
  | 'SUBMIT'
  | 'CANCEL'
  | 'NEXT'
  | 'BACK'
  | 'HOMEPAGE'
  | 'SETTINGS';

export enum ButtonActionType {
  UNKNOWN = 'UNKNOWN',
  SUBMIT = 'SUBMIT',
  CANCEL = 'CANCEL',
  NEXT = 'NEXT',
  BACK = 'BACK',
  HOMEPAGE = 'HOMEPAGE',
  SETTINGS = 'SETTINGS',
}
